import Vue from "vue";
import BlogService from "../../service/BlogService";

export const store = Vue.observable({
  categories:[],
  blogs: [],
  loading: false
});

export const getters = {
  /*
   * Blogs
   */
  getBlog: (id) => {
    return store.blogs.find(blog => blog.id === id)
  },
  getBlogs: () => {
    return store.blogs
  },
  isLoading: () => {
    return store.loading
  },


  /*
   * Categories
   */
  getCategories: () => {
    return store.categories
  },
};

export const mutations = {
  /*
   * Blogs
   */
  addBlog: (blog) => {
    console.log(blog);
    store.blogs.push(blog);
  },
  removeBlog: (blog) => {
    let blogIndex = store.blogs.indexOf(blog);
    store.blogs.splice(blogIndex,1);
  },
  updateBlog: (blog) => (id) => {
    store.blogs.find((blog) => {
      return blog.id === id
    }).content = blog
  },

  /*
   * Categories
   */
  updateCategories: (category) => {
    store.categories.push({category:category})
  },
};

export const actions = {
  /*
   * Blogs
   */
  setBlogs: (token) => {
    store.loading = true;
    return new Promise((fulfill, reject) => {
      BlogService.getBlogs(token).then(response => {
        store.loading = false;
        store.blogs = response.data.sort((a, b) => {
          return new Date(b.createdDate) - new Date(a.createdDate);
        })
        fulfill(response)
      })
    }).catch((reject)=>{
      console.error(reject)
    })
  },

  /*
   * Categories
   */
  setCategories: (token) => {
    return new Promise((fulfill, reject) => {
      BlogService.getCategories(token).then(response => {
        store.categories = response.data
        fulfill(response)
      })
    }).catch((reject)=>{
      console.error(reject)
    })
  }
};